<template>
  <div class="sky__product-screen-reassurances">
    <div v-for="(reinsurance, index) in product.properties.reinsurances" :key="`${index}-reinsurance`" class="sky__product-screen-reassurance">
      <img src="../../../assets/icons/interface-big-circle.svg?img" class="sky__product-screen-reassurance-border" alt="">
      {{ reinsurance }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      required: true,
      type: Object
    }
  }
}
</script>

<style lang="scss" scoped>
.sky__product-screen-reassurances {
  @apply flex text-xxs text-center font-bold mb-3 justify-between ;
  .sky__product-screen-reassurance {
    @apply flex items-center justify-center relative mr-2 px-2;
    width: 90px;
    height: 90px;
    .sky__product-screen-reassurance-border {
      @apply absolute top-0 left-0;
      width: 90px;
      height: 90px;
    }
  }
}
</style>
